module.exports = __webpack_public_path__ + "img/BG-ITEssentials.baaf6be5.jpg";